'use strict';

module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};



//////////////////
// WEBPACK FOOTER
// ./~/contentful/~/axios/lib/cancel/isCancel.js
// module id = 88
// module chunks = 1